import { SectionProps } from './types';

export const scrollIntoView = (element: HTMLElement, offsetVal = 0) => {
  if (!element) return;
  const offset = offsetVal;
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

export const getNameOfSection = (
  sections: Array<SectionProps>,
  id: string
): string => {
  const foundSection = sections.find((section) => section.props.id === id);
  return foundSection ? foundSection.props.name : '';
};

export const getSectionHTMLById = (
  sections: Array<SectionProps>,
  id: string
): HTMLDivElement | null | undefined => {
  const foundSection = sections.find((section) => section.props.id === id);
  return foundSection?.ref?.current;
};
